<template>
  <div class="container-lg auth-layout">
    <div class="auth-container">
      <img
        src="@provise/img/logo.webp"
        alt="logo"
        class="ms-auto me-auto d-block"
      />

      <slot />
    </div>
  </div>
</template>
